"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = require("react");
var _axios = _interopRequireDefault(require("axios"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const useStationStops = _ref => {
  let {
    facilityIDs,
    lang,
    regions
  } = _ref;
  const [stationStops, setStationStops] = (0, _react.useState)([]);
  (0, _react.useEffect)(() => {
    const {
      REACT_APP_PATH
    } = process.env;
    const url = "".concat(REACT_APP_PATH, "/Micado.Ski.Web/Micado.Ski.Web.IO.Api.FacilityApi/List.api");
    _axios.default.all(regions.map(region => {
      const params = [];
      params.push("lang=".concat(lang));
      params.push("pageSize=200");
      params.push("region=".concat(region));
      params.push("typeIDs=".concat(facilityIDs.join(",")));
      return _axios.default.get("".concat(url, "?").concat(params.join("&")));
    })).then(_axios.default.spread(function () {
      const tmpItems = [];
      for (var _len = arguments.length, res = new Array(_len), _key = 0; _key < _len; _key++) {
        res[_key] = arguments[_key];
      }
      res.forEach(response => {
        const {
          data: {
            items = []
          } = {}
        } = response;
        tmpItems.push(...items);
      });
      setStationStops(tmpItems);
    }));
  }, [facilityIDs, lang, regions]);
  return stationStops;
};
var _default = exports.default = useStationStops;